import { createEntityAdapter, createSelector, createSlice, EntityState } from '@reduxjs/toolkit';
import { Json } from '@ff-os/shared-json/Json';
import { PdpState } from '../store';

export const { actions, reducer } = createSlice({
    name: 'scene',
    initialState: {
        id: '-1',
        pluginId: 'none',
        options: {}
    } as Json.Scene<any>,
    reducers: {}
});

export const selectIsProductDisabled = createSelector(
    (state: PdpState) => (state.scene.options as any)?.isProductDisabled ?? false,
    isProductDisabled => isProductDisabled);

export const createOptionBindings = <TOptions, TState extends PdpState>() => ({
    createOptionSelector: <T>(selector: (options: TOptions) => T) => createSelector(
        (state: TState) => state.scene.options as TOptions,
        o => selector(o)),

    createEntityOptionSelectors: <T>(optionsSelector: (options: TOptions) => EntityState<T>) => {
        const adapter = createEntityAdapter<T>();
        return adapter
            .getSelectors<TState>(s => optionsSelector(s.scene.options as TOptions));
    }
});